export const ScheduleTypes = [
  {
    id: null,
    label: 'All schedules'
  },
  {
    id: 1,
    label: 'Full day'
  },
  {
    id: 2,
    label: 'Half day AM'
  },
  {
    id: 3,
    label: 'Half day PM'
  },
  {
    id: 4,
    label: 'Early drop-off'
  },
  {
    id: 5,
    label: 'After school'
  },
  {
    id: 6,
    label: 'Overnight'
  },
  {
    id: 7,
    label: '1st Shift / Day shift'
  },
  {
    id: 8,
    label: '2nd Shift / Swing shift'
  },
  {
    id: 9,
    label: '3rd Shift / Night shift'
  },
  {
    id: 10,
    label: 'Evening care'
  },
  {
    id: 11,
    label: '24 hour'
  },
  {
    id: 12,
    label: 'Drop-in'
  },
  {
    id: 13,
    label: 'Weekend'
  },
  {
    id: 14,
    label: 'Full year'
  },
  {
    id: 15,
    label: 'School year'
  },
  {
    id: 16,
    label: 'Summer care'
  },
  {
    id: 17,
    label: 'Summer camp'
  },
  {
    id: 18,
    label: 'Full time'
  },
  {
    id: 19,
    label: 'Part time'
  },
  {
    id: 20,
    label: 'Late pickup'
  },
  {
    id: 21,
    label: 'Before school'
  },
  {
    id: 22,
    label: 'Extended hours'
  }
];
